<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
*{
  padding: 0;
  margin: 0;
  -webkit-touch-callout:none;  /*系统默认菜单被禁用*/   
  -webkit-user-select:none; /*webkit浏览器*/   
  -khtml-user-select:none; /*早期浏览器*/   
  -moz-user-select:none;/*火狐*/   
  -ms-user-select:none; /*IE10*/   
  user-select:none;   
}
#app{
  /* min-width: 1920px;
  min-height: 1080px; */
  width: 100vw;
  height: 100vh;
  overflow: auto;
}
</style>


// WEBPACK FOOTER //
// src/App.vue